import { get, del, post, put, download } from "@utils/axios";

const api = "reports";
export const getAllDataReq = (payload) => {
  const scope = payload.scope ? `&scope=${encodeURIComponent(payload.scope)}` : "";
  return get(`${api}?page=${payload.page}&filters=${payload.filters}${scope}`)
};

//create report
export const createDataReq = (payload) => {
  return post(`${api}`, payload);
};

export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};
export const cancelRequestReq = (payload) => {
  return post('cancelRequest', payload);
};

export const deleteDataReq = (payload) => {
  const scope = payload.scope ? `&scope=${encodeURIComponent(payload.scope)}` : "";
  return del(`${api}/${payload.id}?page=1&filters=${payload.filters}${scope}`);
};

export const getTenantsReq = (payload) => {
  return get(`${api}/get_tenants`);
};
export const cloneReportInSaasReq = (payload) => {
  return post(`${api}/clone_report`, payload);
};
export const createPredefinedReportReq = (payload) => {
  return post(`${api}/create-predefined-report`, payload);
};

export const getRosterReq = (payload) => {
  return post(`${api}/getRoster`, payload);
};
export const getExpectedTimeReq = (payload) => {
  return get(`${api}/getExpectedTime?&attendance_date=${payload.date}&employment_id=${payload.employment_id}`);
};


export const getInitialDataReq = (payload) => {
  return post(`${api}/get_report_initial_data`, payload);
};

export const getDirectiveFiltersReq = (reportId) => {
  return get(`${api}/${reportId}/directive-filters`);
};

export const createDirectiveFilterReq = (payload) => {
  return post(`${api}/${payload.report_id}/directive-filters`, payload);
};

export const updateDirectiveFilterReq = (payload) => {
  return put(`${api}/directive-filters/${payload.id}`, payload);
};

export const deleteDirectiveFilterReq = (payload) => {
  return del(`${api}/directive-filters/${payload.id}`);
};

export const getFilterReq = (payload) => {
  return get(`filters?${localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1}&fields=page=${payload.page}&filters=${payload.filters}`)
}
export const downloadReportReq = (payload) => {
  return download(`${api}/download?page=${payload.page}&format=${payload.format}&filters=${payload.filters}&employment_id=${payload.employment_id}&selected_columns=${payload.selected_columns || ""}`)
}

//creating report
export const getReportTypesAndTables = (payload) => {
  const scope = payload?.scope ? `?scope=${encodeURIComponent(payload.scope)}` : "";
  return get(`${api}/create${scope}`);
}

export const getTableInfoByIdReq = (id) => {
  return get(`schema_tables/${id}`)
}
//run query
export const getPreviewQueryReq = (payload) => {
  return post(`${api}/preview_query`, payload)
}
//load related tables
// id: 12
// selected_tables[]: 791
// alias: employments
// related_table: 791
export const loadRelatedTablesReq = (payload) => {
  return post(`schema_tables/load_related_table`, payload)
}


//generate report with prefilterd
// payload =
//   id: 39
// page: 1
// filters[sorting]:
// pagination_options[pageNumber]: 1
// pagination_options[pageSize]: 50
// pagination_options[sort]:
// print_call: false
export const generateReportReq = (payload) => {
  return post(`${api}/generate_report`, payload)
}

//generate custom report 

//get inital report data
export const getReportInitialDataReq = (reportId) => {
  return post(`${api}/get_report_initial_data`, reportId)
}

// call when apply filter from dialog box

export const generateCustomReportReq = (payload) => {
  return post(`${api}/generate_report`, payload)
}
export const printCustomReportReq = (payload) => {
  return post(`${api}/print_report`, payload)
}

export const getReportsFromJobsReq = (payload = {}) => {
  return get(`get-report-jobs`, payload);
};
export const downloadReportFromJobsReq = (payload) => {
  const id = typeof payload === "object" ? payload.id : payload;
  const params = typeof payload === "object" ? payload : {};
  return download(`download-report-job/${id}`, params);
};

export const getReportSchedulesReq = (payload = {}) => {
  const page = payload.page || 1;
  const search = encodeURIComponent(payload.search || "");
  const status = encodeURIComponent(payload.status || "");
  const frequency = encodeURIComponent(payload.frequency || "");
  const reportId = encodeURIComponent(payload.report_id || "");
  const scope = encodeURIComponent(payload.scope || "");
  return get(`reportSchedules?page=${page}&search=${search}&status=${status}&frequency=${frequency}&report_id=${reportId}&scope=${scope}`);
};
export const getReportScheduleResourcesReq = (payload = {}) => {
  const params = payload || {};
  const scope = params.scope ? `?scope=${encodeURIComponent(params.scope)}` : "";
  return get(`reportSchedules/resources${scope}`);
};
export const createReportScheduleReq = (payload) => {
  return post(`reportSchedules`, payload);
};
export const updateReportScheduleReq = (payload) => {
  return put(`reportSchedules/${payload.id}`, payload);
};
export const deleteReportScheduleReq = (payload) => {
  return del(`reportSchedules/${payload.id}`);
};
export const runReportScheduleNowReq = (payload) => {
  return post(`reportSchedules/${payload.id}/run-now`, payload);
};
export const pauseReportScheduleReq = (payload) => {
  return post(`reportSchedules/${payload.id}/pause`, payload);
};
export const resumeReportScheduleReq = (payload) => {
  return post(`reportSchedules/${payload.id}/resume`, payload);
};
export const getReportScheduleRunsReq = (payload) => {
  return get(`reportSchedules/${payload.id}/runs`);
};

export const loadReportColumnsReq = (payload) => {
  return get(`${api}/load-report-columns/${payload.id}`)
}

export const generateReportFileReq = (payload) => {
  return download(`${api}/download-report-file?id=${payload.id}&format=${payload.format}&filters=${payload.filters}&employment_id=${payload.employment_id}`)
}
